<!--
 * @Author: Lihao sun sunlihao.cosmo@haier.com
 * @Date: 2024-12-19 09:59:56
 * @LastEditors: Lihao sun sunlihao.cosmo@haier.com
 * @LastEditTime: 2024-12-20 17:18:57
 * @FilePath: src/views/iframe/index.vue
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 -->
<!--
  @Author 22030124/xieyq
  @Date 2023-12-07 14:15:31
  @Description iframe嵌入
-->
<template>
  <div :class="scope.clsPrefix">
    <iframe :class="`${scope.clsPrefix}_frame`" allow="microphone" :src="url" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'SubIframe',
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'sub-iframe'
      }
    }
  },
  // 计算属性
  computed: {
    // 当前路由
    currentRoute() {
      return this.$route
    },
    // 路由信息
    routeMeta() {
      return this.currentRoute?.meta || {}
    },
    // 应用地址
    url() {
      const token = this.$store.state.user.token
      return this.currentRoute.meta.url + '?fromType=eiipIframe&accessToken=' + token || ''
    }
  },
  // 创建完成
  created() { },
  // 挂载完成
  mounted() { },
  // 方法
  methods: {}
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: 'sub-iframe';

.#{$class-prefix} {
  position: relative;
  width: 100%;
  height: 100%;
  &_frame {
    width: 100%;
    height: 100%;
  }
}
</style>
